import React, { Component } from "react";
import PropTypes from "prop-types";
import { injectIntl, FormattedMessage } from "react-intl";
import withStyles from "isomorphic-style-loader/withStyles";
import cx from "classnames";
import {
  Field,
  reduxForm,
  formValueSelector,
  change,
  submit as submitForm,
} from "redux-form";
import { connect } from "react-redux";

import PriceRange from "../../../PriceRange";
import CurrencyConverter from "../../../../CurrencyConverter";

import messages from "../../../../../locale/messages";
import submit from "../../../SearchForm/submit";
import { convert } from "../../../../../helpers/currencyConvertion";

import s from "./Price.css";

const PRICE_STEP = 100;

class Price extends Component {
  static propTypes = {
    className: PropTypes.any,
    searchSettings: PropTypes.shape({
      minPrice: PropTypes.number.isRequired,
      maxPrice: PropTypes.number.isRequired,
      priceRangeCurrency: PropTypes.string.isRequired,
    }).isRequired,
  };

  static defaultProps = {
    isExpand: false,
    searchSettings: {
      priceRangeCurrency: "USD",
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      liveRange: null,
    };
  }

  handleRangeChange = (range) => {
    this.setState({ liveRange: range });
  };

  renderPriceRange = ({
    input,
    label,
    meta: { touched, error },
    className,
    min,
    max,
    rangeCurrency,
    minPrice,
    maxPrice,
    step,
    onRangeChange,
  }) => {
    const { formatMessage } = this.props.intl;
    const { handleSubmit, change } = this.props;
    return (
      <div className={cx(s.space5, s.priceRangePadding)}>
        <PriceRange
          {...input}
          min={min}
          max={max}
          minPrice={minPrice}
          maxPrice={maxPrice}
          from={rangeCurrency}
          step={step || PRICE_STEP}
          onRangeChange={onRangeChange}
        />
      </div>
    );
  };

  render() {
    const {
      className,
      handleTabToggle,
      isExpand,
      searchSettings,
      smallDevice,
      tabletDevice,
    } = this.props;
    const { priceRangeLabel, priceRange, searchResults, currencyBase, currencyRates, currencyTo } = this.props;
    const { liveRange } = this.state;
    const { formatMessage } = this.props.intl;

    let rangeCurrency;
    rangeCurrency = searchSettings?.priceRangeCurrency;

    // Precios de los resultados actuales convertidos a la moneda visible.
    // Si no hay resultados (o faltan tasas), se usan los límites del admin.
    const targetCurrency = currencyTo || currencyBase;
    let resultPrices = [];
    if (searchResults?.length > 0) {
      searchResults.forEach((item) => {
        const amount = item?.listingData?.basePrice;
        const fromCurrency = item?.listingData?.currency;
        if (typeof amount !== 'number' || !isFinite(amount)) return;
        if (currencyRates && currencyBase && fromCurrency && currencyRates[fromCurrency]) {
          const converted = convert(currencyBase, currencyRates, amount, fromCurrency, targetCurrency);
          if (typeof converted === 'number' && isFinite(converted)) resultPrices.push(converted);
        } else if (!currencyRates || !currencyBase) {
          resultPrices.push(amount);
        }
      });
    }

    let boundsMin = searchSettings?.minPrice;
    let boundsMax = searchSettings?.maxPrice;
    if (resultPrices.length > 0) {
      const rawMin = Math.min(...resultPrices);
      const rawMax = Math.max(...resultPrices);
      boundsMin = Math.floor(rawMin / PRICE_STEP) * PRICE_STEP;
      boundsMax = Math.ceil(rawMax / PRICE_STEP) * PRICE_STEP;
      if (!(boundsMax > boundsMin)) boundsMax = boundsMin + PRICE_STEP;
    }

    // Selección actual (redux) fijada dentro de los límites dinámicos
    let selMin = Array.isArray(priceRangeLabel) && isFinite(priceRangeLabel[0]) ? priceRangeLabel[0] : boundsMin;
    let selMax = Array.isArray(priceRangeLabel) && isFinite(priceRangeLabel[1]) ? priceRangeLabel[1] : boundsMax;
    selMin = Math.max(boundsMin, Math.min(selMin, boundsMax));
    selMax = Math.min(boundsMax, Math.max(selMax, boundsMin));
    if (selMin > selMax) {
      selMin = boundsMin;
      selMax = boundsMax;
    }
    const minPriceRange = selMin;
    const maxPriceRange = selMax;

    // Rango efectivo para el conteo en vivo (arrastre actual o selección aplicada)
    let effMin = liveRange?.[0] ?? selMin;
    let effMax = liveRange?.[1] ?? selMax;
    effMin = Math.max(boundsMin, Math.min(effMin, boundsMax));
    effMax = Math.min(boundsMax, Math.max(effMax, boundsMin));

    const hasPrices = resultPrices.length > 0;
    const inRangeCount = hasPrices
      ? resultPrices.filter((p) => p >= effMin && p <= effMax).length
      : 0;

    return (
      <div className={className}>
        <div>
          <p className={cx(s.moreFilterTitle, s.textBold)}>
            <FormattedMessage {...messages.priceRange} />
          </p>
          <p className={cx(s.captionTitle, s.marginBottomNone)}>
            <FormattedMessage {...messages.priceTextForTotalPrice} />
          </p>
        </div>

        {smallDevice || tabletDevice ? (
          <div className={cx(s.captionTitle, "priceBoxRTL", s.captionCurrenySection)}>
            <CurrencyConverter amount={minPriceRange} from={rangeCurrency} />
            <span>{" - "}</span>
            <CurrencyConverter amount={maxPriceRange} from={rangeCurrency} />
          </div>
        ) : (
          <div className={cx(s.captionTitle, s.space4, "priceBoxRTL", s.captionCurrenySection)}>
            <span className={s.boxCss}>
              <div className={cx(s.minMaxCss, "rtlminMaxCss")}>
                <FormattedMessage {...messages.minPrice} />
              </div>
              <CurrencyConverter
                amount={minPriceRange}
                from={rangeCurrency}
                className={cx(s.showPrice, "showPriceRTL")}
              />
            </span>
            <span className={cx(s.lineCss)}></span>
            <span className={s.boxCss}>
              <div className={cx(s.minMaxCss, "rtlminMaxCss")}>
                <FormattedMessage {...messages.maxPrice} />
              </div>
              <CurrencyConverter
                amount={maxPriceRange}
                from={rangeCurrency}
                className={cx(s.showPrice, "showPriceRTL")}
              />
            </span>
          </div>
        )}
        <Field
          name="priceRange"
          component={this.renderPriceRange}
          min={boundsMin}
          max={boundsMax}
          minPrice={minPriceRange}
          maxPrice={maxPriceRange}
          rangeCurrency={rangeCurrency}
          step={PRICE_STEP}
          onRangeChange={this.handleRangeChange}
        />
        {hasPrices && (
          <p className={cx(s.captionTitle, s.countLine)}>
            <FormattedMessage {...messages.propertiesInRange} values={{ count: inRangeCount }} />
          </p>
        )}
      </div>
    );
  }
}

Price = reduxForm({
  form: "SearchForm", // a unique name for this form
  onSubmit: submit,
  destroyOnUnmount: false,
})(Price);

// Decorate with connect to read form values
const selector = formValueSelector("SearchForm"); // <-- same as form name

const mapState = (state) => ({
  fieldsSettingsData: state?.listingFields?.data,
  priceRangeLabel: selector(state, "priceRangeLabel"),
  priceRange: selector(state, "priceRange"),
  searchResults: state?.search?.data,
  currencyBase: state?.currency?.base,
  currencyRates: state?.currency?.rates,
  currencyTo: state?.currency?.to,
});

const mapDispatch = {
  change,
  submitForm,
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(Price)));
